// ErrorDetailsModal.tsx
import React from 'react';
import { Modal, Paper, Box, Typography, List, ListItem, ListItemIcon, ListItemText, IconButton } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import CloseIcon from '@mui/icons-material/Close';

interface ErrorDetailsModalProps {
  open: boolean;
  onClose: () => void;
  errors: string[] | null;
}

const ErrorDetailsModal: React.FC<ErrorDetailsModalProps> = ({ open, onClose, errors }) => (
  <Modal open={open} onClose={onClose} aria-labelledby="error-details-title">
    <Paper
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        padding: 3,
        outline: 'none',
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h6" id="error-details-title">
          Error Details
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>
      {errors && errors.length > 0 ? (
        <List>
          {errors.map((error, index) => (
            <ListItem key={index}>
              <ListItemIcon>
                <ErrorIcon color="error" />
              </ListItemIcon>
              <ListItemText primary={error} />
            </ListItem>
          ))}
        </List>
      ) : (
        <Typography variant="body2" color="textSecondary">
          No errors available for this row.
        </Typography>
      )}
    </Paper>
  </Modal>
);

export default ErrorDetailsModal;
